module.exports=function(scope){ return `// Signal to the FaceTec SDK that time based session images should be captured
ZoomSDK.enableTimeBasedSessionImages = true

// Capture a User Session
let sessionVC = Zoom.sdk.createSessionVC(delegate: self)
self.present(sessionVC, animated: true, completion: nil)

// Sample code to handle the session result
func onZoomSessionResult(result: ZoomSessionResult) {
    print("Session result: \\(result.status)")

    // Session failed
    if result.status != .UserProcessedSuccessfully {
        // Handle results here
        return
    }

    if result.faceMetrics != nil {
        // Get the time based session image(s) if available
        let timeBasedSessionImages = result.faceMetrics?.timeBasedSessionImages
        // Check the time based session images count
        NSLog("Time based session image count result: \(timeBasedSessionImages.count)")
    }
    // Send the data to your chosen API for processing
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/38-time-based-images.swift.tpl